import { Outlet, NavLink, useNavigate } from "react-router";
import {
  Users,
  Package,
  Warehouse,
  UserCog,
  DollarSign,
  MapPin,
  ClipboardList,
  Map as MapIcon,
  ReceiptText,
  Truck,
  Image,
  Tag,
  BarChart3,
} from "lucide-react";
import { useEffect } from "react";

const sidebarItems = [
  { to: "orders", label: "Orders", icon: Package },
  { to: "customers", label: "Customers", icon: Users },
  { to: "depots", label: "Depots", icon: Warehouse },
  { to: "operators", label: "Operators", icon: UserCog },
  { to: "pricings", label: "Pricing", icon: DollarSign },
  { to: "service-areas", label: "Service Areas", icon: MapPin },
  { to: "tasks", label: "Tasks", icon: ClipboardList },
  { to: "invoices", label: "Invoices", icon: ReceiptText },
  { to: "trips", label: "Trips", icon: Truck },
  { to: "address-medias", label: "Address Medias", icon: Image },
  { to: "tags", label: "Tags", icon: Tag },
  { to: "analytics", label: "Analytics", icon: BarChart3 },
];

export function TableLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    function handleKeyPress(event: KeyboardEvent) {
      // Ignore if user is typing in an input or textarea
      if (
        event.target instanceof HTMLElement &&
        (event.target.tagName === "INPUT" ||
          event.target.tagName === "TEXTAREA")
      ) {
        return;
      }

      // Handle keyboard shortcuts
      if (event.key === "M") {
        void navigate("/dashboard");
      }
    }

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen">
      {/* Header */}
      <header className="bg-black border-b shadow-sm z-10">
        <div className="px-4 sm:px-24 py-4 flex justify-between items-center">
          <h1 className="text-xl font-semibold text-white">Admin Dashboard</h1>
          <NavLink
            to="/dashboard"
            className="flex items-center gap-2 text-white hover:text-gray-200"
            title="Go back to map (M)"
          >
            <MapIcon className="w-5 h-5" />
            Go back to map
          </NavLink>
        </div>
      </header>

      {/* Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside className="w-64 bg-gray-50 border-r flex-shrink-0">
          <nav className="p-4 space-y-2">
            {sidebarItems.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded-md transition-colors ${
                    isActive
                      ? "bg-gray-900 text-white"
                      : "text-gray-600 hover:bg-gray-100"
                  }`
                }
              >
                <Icon className="h-5 w-5" />
                {label}
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Content Area */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
